module.exports = __webpack_public_path__ + "0a2931c0c0630dbfbc0175ffb0c801a5.MP3";